class SpinnerService {
	appendTo($element = $('body')) {
		if($element) {
			$element.append(`<div class="loading-spinner"><div class="loading-spinner-img"></div></div>`);
		}
	}

	removeFrom($element = $('body')) {
		$element.find('.loading-spinner').remove();
	}
}

export let spinnerService = new SpinnerService();
